import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ASSETS, BUY_URL, X_URL } from "@/config";
import { Corners } from "@/components/ui-kit";

const LINKS = [
  { to: "/", label: "HOME" },
  { to: "/network", label: "NETWORK" },
  { to: "/agents", label: "AGENTS" },
  { to: "/machines", label: "MACHINES" },
  { to: "/tasks", label: "TASKS" },
  { to: "/economy", label: "ECONOMY" },
  { to: "/terminal", label: "TERMINAL" },
  { to: "/thesis", label: "THESIS" },
  { to: "/docs", label: "DOCS" },
  { to: "/about", label: "ABOUT" },
  { to: "/launch", label: "LAUNCH" },
];

const MobileMenu = ({ open, onClose, pathname }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-testid="mobile-menu"
        className="fixed inset-0 z-40 lg:hidden bg-arc-black/95 grid-bg scanlines"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        role="dialog"
        aria-label="Navigation menu"
      >
        <div className="h-full flex flex-col pt-20 pb-6 px-6 overflow-y-auto">
          <div className="flex items-center justify-between mb-6">
            <div className="font-mono text-[10px] tracking-[0.3em] text-arc-cyan">MODULE SELECT</div>
            <div className="font-mono text-[10px] tracking-[0.3em] text-arc-silver/40">SYS.NAV // v1.0</div>
          </div>
          <nav className="flex-1">
            {LINKS.map((l, i) => (
              <motion.div key={l.to} initial={{ opacity: 0, x: -16 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.03 * i, duration: 0.25 }}>
                <Link
                  to={l.to}
                  onClick={onClose}
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                  className={`group relative flex items-center justify-between py-2.5 border-b border-arc-blue/10 ${pathname === l.to ? "text-arc-cyan" : "text-arc-silver"}`}
                >
                  <span className="flex items-center gap-4">
                    <span className="font-mono text-[10px] text-arc-electric/60">{String(i).padStart(2, "0")}</span>
                    <span className="font-display text-2xl font-bold tracking-wide group-hover:text-arc-cyan transition-colors">{l.label}</span>
                  </span>
                  <span className={`font-mono text-[10px] tracking-[0.2em] ${pathname === l.to ? "text-arc-green" : "text-arc-silver/30"}`}>
                    {pathname === l.to ? "ACTIVE" : "READY"}
                  </span>
                </Link>
              </motion.div>
            ))}
          </nav>
          <div className="mt-6 relative hud-panel p-4">
            <Corners />
            <div className="flex items-center gap-4">
              <img src={ASSETS.logo} alt="" className="h-10 w-auto" />
              <div className="font-mono text-[10px] text-arc-silver/50 tracking-wider leading-relaxed">
                ARCMECH NETWORK<br />
                <span className="text-arc-green">● ONLINE</span> · <span className="text-arc-silver/40">TELEMETRY: SIM</span>
              </div>
            </div>
            <div className="flex gap-3 mt-4">
              <a href={BUY_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-buy-button" className="clip-btn flex-1 text-center bg-arc-blue text-arc-white font-mono text-[11px] tracking-[0.2em] py-3 border border-arc-electric/70">
                BUY $ARCMECH
              </a>
              <a href={X_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-x-link" className="clip-btn flex-1 text-center border border-arc-silver/25 text-arc-silver font-mono text-[11px] tracking-[0.2em] py-3">
                FOLLOW ON X
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default MobileMenu;
